import { render } from "./EmployeeLiquidation.vue?vue&type=template&id=2c8b299e"
import script from "./EmployeeLiquidation.vue?vue&type=script&lang=js"
export * from "./EmployeeLiquidation.vue?vue&type=script&lang=js"

import "./EmployeeLiquidation.vue?vue&type=style&index=0&id=2c8b299e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__